module.exports = __webpack_public_path__ + "static/media/mountains.c2874bdb.svg";